export var fabricIndex=function(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:-1,b=a;return function(){return b+=1,b}};
//# sourceMappingURL=fabricIndex.js.map